import { Serializable } from '../../../core/models/serializable';
import { PromoEmailAttachmentModel } from './promo-email-attachment-model';
import { UserModel } from '@admin/core/user-model.model';
import { PromoEmailTemplateStatus } from './promo-email-template-status.enum';
import { PortfolioModel } from '@admin/portfolios/shared/models/portfolio-model';

export class PromoEmailTemplateModel
  implements Serializable<PromoEmailTemplateModel>
{
  fromObject(object: any): PromoEmailTemplateModel {
    Object.assign(this, object);
    this.attachments = [];
    this.portfolios = [];

    if (
      object.attachments &&
      object.attachments.length &&
      object.attachments.length > 0
    ) {
      object.attachments.forEach((a) => {
        if (a.filename && a.displayName) {
          let t = new PromoEmailAttachmentModel(a.filename, a.displayName);
          t = t.fromObject(a);
          this.attachments.push(t);
        }
      });
    }

    if (
      object.portfolios &&
      object.portfolios.length &&
      object.portfolios.length > 0
    ) {
      object.portfolios.forEach((p) => {
        let t = new PortfolioModel();
        t = t.fromObject(p);
        this.portfolios.push(t);
      });
    }
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public promoEmailTemplateId: number;
  public name: string;
  public subject: string;
  public content: string;
  public validFrom: Date;
  public validTo: Date;
  public statusId: PromoEmailTemplateStatus;
  public createUser: UserModel;
  public createDate: Date;
  public lastChangeUser: UserModel;
  public lastChangeDate: Date;
  public approveUser: UserModel;
  public approveDate: Date;
  public deleteUser: UserModel;
  public deleteDate: Date;
  public isDeleted: boolean;

  public attachments: PromoEmailAttachmentModel[];
  public portfolios: PortfolioModel[];

  constructor() {
    this.attachments = [];
    this.portfolios = [];
  }
}
